module.exports = __webpack_public_path__ + "static/media/google-reviews-badge.61778d62.png";